(function () {
  var CACHE_KEY = "btech-installer-geo-v1";

  function boot(scope) {
    var root = (scope || document).querySelector("[data-installers]");
    if (!root || root.dataset.ready === "1" || !window.maplibregl) return;

    var configEl = root.querySelector("[data-ip-config]");
    var mapEl = root.querySelector("[data-ip-map]");
    if (!configEl || !mapEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (err) {
      return;
    }

    root.dataset.ready = "1";

    var lang = config.lang === "de" ? "de" : "en";
    var dealers = (config.dealers || []).map(function (dealer) {
      return {
        id: String(dealer.id || ""),
        name: dealer.name || "",
        country: dealer.country || "",
        address: dealer.address || "",
        phone: dealer.phone || "",
        email: dealer.email || "",
        website: dealer.website || "",
        note: dealer.note || "",
        lat: coord(dealer.lat),
        lng: coord(dealer.lng),
        countrycode: countryCodeFromName(dealer.country)
      };
    });

    var searchInput = root.querySelector("[data-ip-search]");
    var suggestEl = root.querySelector("[data-ip-suggest]");
    var spinEl = root.querySelector("[data-ip-spin]");
    var clearBtn = root.querySelector("[data-ip-clear]");
    var notFound = lang === "de" ? "Es wurde nichts gefunden." : "Nothing was found.";
    var busyIds = {};
    var busySeq = 0;
    var emptyEl = root.querySelector("[data-ip-empty]");
    var cardsEl = root.querySelector("[data-ip-cards]");
    var mobileDetail = root.querySelector("[data-ip-mobile-detail]");
    var phoneQuery = window.matchMedia("(max-width: 989px)");
    var lastShown = null;
    var mobilePinId = null;
    var routedId = null;
    var routedAltId = null;
    var statusEl = root.querySelector("[data-ip-status]");
    var suggestItems = [];
    var suggestIndex = -1;
    var searchTimer = 0;
    var suggestGen = 0;
    var placeAbort = null;
    var queryActive = false;
    var activePlace = null;
    var markers = {};
    var originMarker = null;
    var flagMarker = null;
    var flaggedPin = null;
    var routeToken = 0;
    var countryToken = 0;
    var countryShapes = {};
    var mapReady = false;
    var cache = readCache();

    var map = new maplibregl.Map({
      container: mapEl,
      style: "https://tiles.openfreemap.org/styles/positron",
      center: [8.23, 46.82],
      zoom: 4.1,
      minZoom: 2,
      maxZoom: 18,
      attributionControl: true
    });
    map.addControl(new maplibregl.NavigationControl({ showCompass: false, visualizePitch: false }), "top-left");
    map.on("load", function () {
      mapReady = true;
      applyMapLanguage();
      addRouteLayers();
      dealers.forEach(function (dealer) {
        if (dealer.lat != null && dealer.lng != null) addMarker(dealer);
      });
      localizeCountryLabels();
      if (!viewCountryChosen) fitHome(0);
      else fitRememberedCountry();
      geocodeMissing();
    });

    root.addEventListener("click", function (event) {
      var hit = event.target.closest("[data-ip-focus]");
      if (!hit || !root.contains(hit)) return;
      var card = hit.closest("[data-ip-card]");
      if (!card) return;
      focusDealer(card.dataset.id);
    });

    if (searchInput) {
      searchInput.addEventListener("input", scheduleSuggest);
      searchInput.addEventListener("keyup", function (event) {
        if (event.key === "Enter" || event.key === "Escape" || event.key === "ArrowUp" || event.key === "ArrowDown") return;
        scheduleSuggest();
      });

      searchInput.addEventListener("keydown", function (event) {
        if (event.key === "ArrowDown" || event.key === "ArrowUp") {
          if (suggestEl.hidden) return;
          event.preventDefault();
          var next = event.key === "ArrowDown" ? suggestIndex + 1 : suggestIndex - 1;
          setSuggestIndex(next);
          return;
        }
        if (event.key === "Enter") {
          event.preventDefault();
          window.clearTimeout(searchTimer);
          suggestGen += 1;
          var typed = searchInput.value.trim();
          var countryItem = matchingCountryItem(typed) || instantCountries(typed, lang)[0];
          if (suggestIndex < 0 && (countryCodeFromName(typed) || (countryItem && countryItem.feature && countryItem.feature.kind === "country" && norm(countryItem.label).indexOf(norm(typed)) === 0 && norm(typed).length >= 3))) {
            if (countryItem && countryItem.feature && countryItem.feature.kind === "country") pickSuggest(countryItem);
            else commitQuery(typed);
            return;
          }
          if (!suggestEl.hidden && suggestItems.length) {
            var picked = suggestIndex >= 0 ? suggestItems[suggestIndex] : suggestItems[0];
            pickSuggest(picked);
          } else {
            commitQuery(typed);
          }
          return;
        }
        if (event.key === "Escape") closeSuggest();
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener("click", function () {
        if (searchInput) searchInput.value = "";
        clearBtn.hidden = true;
        closeSuggest();
        resetView();
        if (searchInput) searchInput.focus();
      });
    }

    document.addEventListener("click", function (event) {
      if (!root.contains(event.target)) closeSuggest();
    });

    function addMarker(dealer) {
      if (markers[dealer.id] || dealer.lat == null || dealer.lng == null) return;
      var pin = document.createElement("button");
      pin.type = "button";
      pin.className = "ip__pin";
      pin.setAttribute("aria-label", dealer.name || "Einbaupartner");
      var marker = new maplibregl.Marker({ element: pin, anchor: "center" })
        .setLngLat([dealer.lng, dealer.lat])
        .addTo(map);
      pin.addEventListener("mousedown", function (event) { event.stopPropagation(); });
      pin.addEventListener("touchstart", function (event) { event.stopPropagation(); }, { passive: true });
      pin.addEventListener("mouseenter", function () { showPinInfo(dealer, false); });
      pin.addEventListener("mouseleave", scheduleHidePinInfo);
      pin.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        selectDealer(dealer.id);
      });
      markers[dealer.id] = marker;
    }

    function geocodeMissing() {
      var pending = dealers.filter(function (dealer) {
        return dealer.lat == null || dealer.lng == null;
      });
      if (!pending.length) return;
      if (statusEl) statusEl.hidden = false;
      pending.reduce(function (chain, dealer) {
        return chain.then(function () {
          return geocodeDealer(dealer).then(function () {
            return wait(280);
          });
        });
      }, Promise.resolve()).then(function () {
        if (statusEl) statusEl.hidden = true;
      });
    }

    function geocodeDealer(dealer) {
      var query = [dealer.address, dealer.country].filter(Boolean).join(", ");
      if (!query) return Promise.resolve();
      var key = norm(query);
      if (cache[key]) {
        applyGeo(dealer, cache[key]);
        return Promise.resolve();
      }
      return photon(query, 1).then(function (features) {
        var feature = features[0];
        if (!feature) return;
        var saved = {
          lat: feature.lat,
          lng: feature.lng,
          countrycode: feature.countrycode || ""
        };
        cache[key] = saved;
        writeCache(cache);
        applyGeo(dealer, saved);
        if (activePlace) showPlace(activePlace.feature, activePlace.query);
      });
    }

    function applyGeo(dealer, saved) {
      dealer.lat = saved.lat;
      dealer.lng = saved.lng;
      if (saved.countrycode) dealer.countrycode = saved.countrycode;
      addMarker(dealer);
    }

    function focusDealer(id) {
      var dealer = dealers.find(function (item) { return item.id === id; });
      if (!dealer) return;
      mountMobileCard(id);
      setActive(id);
      closeSuggest();
      if (dealer.lat == null || dealer.lng == null) return;
      map.flyTo({ center: [dealer.lng, dealer.lat], zoom: 14, duration: motion() });
    }

    var pinPopup = null;
    var pinPopupId = null;
    var pinPopupPinned = false;
    var pinPopupHideTimer = null;
    var pinPopupClosing = false;
    var pinCamera = null;
    var viewCountryCode = "CH";
    var viewCountryChosen = false;
    // West, north, east, south. Center stays on Switzerland. Metropolitan France, Germany and Austria sit almost fully in frame.
    var HOME_EXTENT = [-5.15, 55.06, 21.61, 38.58];

    function showPinInfo(dealer, pinned) {
      if (!dealer || dealer.lat == null || dealer.lng == null) return;
      if (!pinned && pinPopupPinned) return;
      window.clearTimeout(pinPopupHideTimer);
      if (pinned) pinPopupPinned = true;
      if (pinPopup && pinPopupId === dealer.id) return;
      pinPopupClosing = true;
      if (pinPopup) pinPopup.remove();
      pinPopupClosing = false;
      var node = document.createElement("div");
      node.className = "ip__popup";
      var title = document.createElement("strong");
      title.textContent = dealer.name || "";
      node.appendChild(title);
      var lines = String(dealer.address || "").split(/\n/).map(function (line) {
        return line.trim();
      }).filter(Boolean);
      var countryName = localizedCountry(dealer.country, dealer.countrycode);
      if (countryName && lines.join(" ").indexOf(countryName) === -1 && lines.join(" ").indexOf(dealer.country) === -1) lines.push(countryName);
      if (lines.length) {
        var place = document.createElement("span");
        place.className = "ip__popup-address";
        place.textContent = lines.join("\n");
        node.appendChild(place);
      }
      if (dealer.phone) {
        node.appendChild(popupAnchor("ip__popup-phone", "tel:" + String(dealer.phone).replace(/\s/g, ""), dealer.phone));
      }
      if (dealer.website) {
        node.appendChild(popupAnchor("ip__popup-web", dealer.website, websiteLabel(dealer.website)));
      }
      var maps = document.createElement("div");
      maps.className = "ip__popup-maps";
      var here = dealer.lat + "," + dealer.lng;
      var q = encodeURIComponent(dealer.name || here);
      maps.appendChild(popupAnchor(
        "ip__popup-google",
        "https://www.google.com/maps/search/?api=1&query=" + here,
        "Google Maps"
      ));
      maps.appendChild(popupAnchor(
        "ip__popup-apple",
        "https://maps.apple.com/?ll=" + here + "&q=" + q,
        lang === "de" ? "Apple Karten" : "Apple Maps"
      ));
      node.appendChild(maps);
      pinPopupId = dealer.id;
      if (!pinned) pinPopupPinned = false;
      pinPopup = new maplibregl.Popup({
        closeButton: true,
        closeOnClick: true,
        focusAfterOpen: false,
        offset: 16,
        anchor: "bottom",
        maxWidth: "280px"
      }).setLngLat([dealer.lng, dealer.lat]).setDOMContent(node).addTo(map);
      pinPopup.on("close", function () {
        if (pinPopupId === dealer.id) {
          pinPopup = null;
          pinPopupId = null;
          pinPopupPinned = false;
        }
        if (!pinPopupClosing) restorePinCamera();
      });
      var popupEl = pinPopup.getElement();
      if (popupEl) {
        var closeBtn = popupEl.querySelector(".maplibregl-popup-close-button");
        if (closeBtn) {
          closeBtn.tabIndex = -1;
          closeBtn.blur();
        }
        popupEl.addEventListener("mouseenter", function () { window.clearTimeout(pinPopupHideTimer); });
        popupEl.addEventListener("mouseleave", scheduleHidePinInfo);
      }
    }

    function popupAnchor(className, href, text) {
      var anchor = document.createElement("a");
      anchor.className = className;
      anchor.href = href;
      if (href.indexOf("tel:") !== 0) {
        anchor.target = "_blank";
        anchor.rel = "noopener noreferrer";
      }
      anchor.textContent = text;
      return anchor;
    }

    function websiteLabel(url) {
      return String(url || "").replace(/^https?:\/\//, "").replace(/\/$/, "");
    }

    function scheduleHidePinInfo() {
      if (pinPopupPinned) return;
      window.clearTimeout(pinPopupHideTimer);
      pinPopupHideTimer = window.setTimeout(function () {
        if (!pinPopupPinned) closePinInfo();
      }, 160);
    }

    function closePinInfo() {
      window.clearTimeout(pinPopupHideTimer);
      pinPopupPinned = false;
      pinPopupId = null;
      pinCamera = null;
      if (!pinPopup) return;
      pinPopupClosing = true;
      pinPopup.remove();
      pinPopup = null;
      pinPopupClosing = false;
    }

    function zoomToDealer(dealer) {
      if (!dealer || dealer.lat == null || dealer.lng == null) return;
      if (!pinCamera) {
        var center = map.getCenter();
        pinCamera = { lng: center.lng, lat: center.lat, zoom: map.getZoom() };
      }
      map.flyTo({ center: [dealer.lng, dealer.lat], zoom: 12, duration: motion() ? 2200 : 0 });
    }

    function restorePinCamera() {
      if (!pinCamera) return;
      var cam = pinCamera;
      pinCamera = null;
      map.flyTo({ center: [cam.lng, cam.lat], zoom: cam.zoom, duration: motion() ? 2200 : 0 });
    }

    function selectDealer(id) {
      var dealer = dealers.find(function (item) { return item.id === id; });
      if (!dealer) return;
      closeSuggest();
      if (!routedId) {
        mobilePinId = null;
        homeCards();
      }
      showPinInfo(dealer, true);
      zoomToDealer(dealer);
    }

    function setActive(id) {
      root.querySelectorAll("[data-ip-card]").forEach(function (card) {
        card.classList.toggle("ip__card--active", card.dataset.id === id);
      });
      var card = root.querySelector('[data-ip-card][data-id="' + cssEscape(id) + '"]');
      if (!card) return;
      if (card.closest(".ip__below") && phoneLayout()) {
        frameRoute();
        return;
      }
      card.scrollIntoView({ block: "nearest" });
    }

    function phoneLayout() {
      return window.matchMedia("(max-width: 749px)").matches;
    }

    function clearMapFrame() {
      mapEl.style.height = "";
      mapEl.style.maxHeight = "";
      mapEl.style.minHeight = "";
      mapEl.style.flex = "";
      if (map) map.resize();
    }

    function frameRoute() {
      if (!phoneLayout()) return;
      if (searchInput) searchInput.blur();
      var below = root.querySelector(".ip__below");
      var col = mapEl.parentElement;
      if (!col || !below) return;
      var header = document.querySelector(".section-header");
      var headerH = header ? Math.ceil(header.getBoundingClientRect().height) : 64;
      var viewH = window.innerHeight;
      if (window.visualViewport && window.visualViewport.height > viewH - 80) {
        viewH = Math.round(window.visualViewport.height);
      }
      var belowH = below.offsetHeight;
      var mapH = Math.max(260, Math.floor(viewH - headerH - belowH - 24));
      mapEl.style.flex = "0 0 auto";
      mapEl.style.height = mapH + "px";
      mapEl.style.maxHeight = mapH + "px";
      mapEl.style.minHeight = mapH + "px";
      if (map) map.resize();
      var top = col.getBoundingClientRect().top + window.scrollY - headerH - 8;
      window.scrollTo(0, Math.max(0, top));
    }

    if (!root.dataset.frameBound) {
      root.dataset.frameBound = "1";
      var frameTimer = 0;
      function queueFrame() {
        if (!routedId || !phoneLayout()) return;
        window.clearTimeout(frameTimer);
        frameTimer = window.setTimeout(frameRoute, 80);
      }
      window.addEventListener("resize", queueFrame);
      if (window.visualViewport) window.visualViewport.addEventListener("resize", queueFrame);
    }

    function resetView() {
      queryActive = false;
      activePlace = null;
      closePinInfo();
      clearCountry();
      setPins(null);
      clearRoute();
      showDealers(dealers, config.empty);
      fitRememberedCountry();
    }

    function fitAll() {
      var points = dealers.filter(function (dealer) {
        return dealer.lat != null && dealer.lng != null;
      });
      if (!points.length) {
        map.jumpTo({ center: [8.4, 46.9], zoom: 2 });
        return;
      }
      fitTo(points);
    }

    function homeCards() {
      if (!mobileDetail || !cardsEl) return;
      mobileDetail.querySelectorAll("[data-ip-card]").forEach(function (card) {
        cardsEl.appendChild(card);
      });
    }

    function cardById(id) {
      return root.querySelector('[data-ip-card][data-id="' + cssEscape(id) + '"]');
    }

    function mountMobileCard(id) {
      if (!mobileDetail || !cardsEl) return;
      mobilePinId = id;
      homeCards();
      var card = cardById(id);
      if (!card) return;
      card.hidden = false;
      mobileDetail.appendChild(card);
    }

    function mountMobileFromList(list, caption) {
      if (!mobileDetail || !cardsEl) return;
      if (mobilePinId) {
        mountMobileCard(mobilePinId);
        return;
      }
      if (!queryActive || !list || !list.length) return;
      var nearestLabel = lang === "de" ? "Nächster Einbaupartner" : "Nearest installer";
      if (caption && caption !== nearestLabel) return;
      var pick = caption === nearestLabel ? list.slice(0, 1) : list;
      pick.forEach(function (dealer) {
        var card = cardById(dealer.id);
        if (!card) return;
        card.hidden = false;
        mobileDetail.appendChild(card);
      });
    }

    function showDealers(list, emptyText, caption, keepRoute) {
      if (!cardsEl) return;
      if (!keepRoute) mobilePinId = null;
      homeCards();
      var visible = {};
      list.forEach(function (dealer) { visible[dealer.id] = true; });
      cardsEl.querySelectorAll("[data-ip-card]").forEach(function (card) {
        card.hidden = !visible[card.dataset.id];
      });
      list.forEach(function (dealer) {
        var card = cardsEl.querySelector('[data-ip-card][data-id="' + cssEscape(dealer.id) + '"]');
        if (card) cardsEl.appendChild(card);
      });
      if (emptyEl) {
        emptyEl.classList.toggle("ip__empty--label", !!caption);
        if (caption) {
          emptyEl.hidden = false;
          emptyEl.textContent = caption;
        } else {
          emptyEl.hidden = list.length > 0;
          if (!list.length) emptyEl.textContent = emptyText || config.none;
        }
      }
      var stage = root.querySelector(".ip__stage");
      if (stage) stage.classList.remove("ip__stage--map-only");
      lastShown = { list: list, caption: caption || "" };
      mountMobileFromList(list, caption || "");
      if (!keepRoute) clearRoute();
    }

    if (phoneQuery.addEventListener) {
      phoneQuery.addEventListener("change", function () {
        if (mobilePinId) {
          mountMobileCard(mobilePinId);
          return;
        }
        if (lastShown) mountMobileFromList(lastShown.list, lastShown.caption);
      });
    }

    function showPlaceOrNearest(value, feature, done) {
      done = done || function () {};
      clearCountry();
      setPins(null);
      var matches = textMatches(value);
      if (matches.length) {
        showDealers(matches, notFound);
        done();
        return;
      }
      if (feature && feature.lat != null) {
        showNearest(feature, done);
        return;
      }
      photon(value, 1).then(function (features) {
        if (searchInput && searchInput.value.trim() !== value) {
          done();
          return;
        }
        if (features[0]) showNearest(features[0], done);
        else {
          showDealers([], notFound);
          done();
        }
      }).catch(function () {
        if (!(searchInput && searchInput.value.trim() !== value)) showDealers([], notFound);
        done();
      });
    }

    function showNearest(place, done) {
      done = done || function () {};
      rememberCountry(place);
      var ranked = dealers.filter(function (dealer) {
        return dealer.lat != null && dealer.lng != null;
      }).sort(function (a, b) {
        return distance(place, a) - distance(place, b);
      });
      if (!ranked.length) {
        showDealers([], notFound);
        done();
        return;
      }
      showDealers(
        [ranked[0]],
        config.none,
        lang === "de" ? "Nächster Einbaupartner" : "Nearest installer"
      );
      setActive(ranked[0].id);
      var token = routeToken;
      Promise.all(ranked.slice(0, 3).map(function (dealer) {
        return routeDuration(place, dealer).then(function (seconds) {
          return { dealer: dealer, seconds: seconds };
        });
      })).then(function (rows) {
        if (token !== routeToken) return;
        var ok = rows.filter(function (row) { return row.seconds != null; }).sort(function (a, b) {
          return a.seconds - b.seconds;
        });
        var best = ok[0] ? ok[0].dealer : ranked[0];
        var caption = lang === "de" ? "Nächster Einbaupartner" : "Nearest installer";
        showDealers([best], config.none, caption, true);
        setActive(best.id);
        drawRoute(place, best);
        var altEl = root.querySelector("[data-ip-route-alt]");
        if (altEl) altEl.hidden = true;
        routedAltId = null;
      }).catch(function () {
        if (token !== routeToken) return;
        drawRoute(place, ranked[0]);
      }).then(function () {
        done();
      });
    }

    function routePath(from, dealer) {
      var lines = String(dealer.address || "").split(/\n/).map(function (line) {
        return line.trim();
      }).filter(Boolean);
      var where = dealer.name || "";
      if (lines.length) where = where ? where + ", " + lines[lines.length - 1] : lines[lines.length - 1];
      return (from.label || "") + " → " + where;
    }

    function similarDrive(first, second) {
      var diff = second - first;
      if (diff < 0) return false;
      return diff <= Math.max(5 * 60, first * 0.3);
    }

    function routeDuration(from, dealer) {
      var url = "https://router.project-osrm.org/route/v1/driving/" +
        from.lng + "," + from.lat + ";" + dealer.lng + "," + dealer.lat + "?overview=false";
      return fetch(url).then(function (res) {
        if (!res.ok) throw new Error("route");
        return res.json();
      }).then(function (data) {
        var route = data && data.routes && data.routes[0];
        return route ? route.duration : null;
      }).catch(function () { return null; });
    }

    function showAlternate(from, dealer, seconds) {
      routedAltId = dealer && dealer.id ? dealer.id : null;
      var block = root.querySelector("[data-ip-route-alt]");
      if (!block) return;
      var timeEl = root.querySelector("[data-ip-route-alt-time]");
      var pathEl = root.querySelector("[data-ip-route-alt-path]");
      var google = root.querySelector("[data-ip-route-alt-google]");
      var apple = root.querySelector("[data-ip-route-alt-apple]");
      var links = mapLinks(from, dealer);
      var label = formatDuration(seconds);
      if (timeEl) timeEl.textContent = label;
      if (pathEl) pathEl.textContent = routePath(from, dealer);
      if (google) google.href = links.google;
      if (apple) apple.href = links.apple;
      block.hidden = false;
      setCardRoute(dealer, links, label + (lang === "de" ? " mit dem Auto" : " by car"));
    }

    var ignoreSuggest = false;

    function scheduleSuggest() {
      if (ignoreSuggest) return;
      var value = searchInput.value.trim();
      if (clearBtn) clearBtn.hidden = value.length === 0;
      window.clearTimeout(searchTimer);
      if (!value) {
        suggestGen += 1;
        clearBusy();
        closeSuggest();
        resetView();
        return;
      }
      searchTimer = window.setTimeout(function () {
        buildSuggest(value);
      }, 50);
    }

    function buildSuggest(value) {
      var gen = ++suggestGen;
      var bias = biasPoint();
      var local = textMatches(value).slice(0, 4).map(function (dealer) {
        return {
          kind: "dealer",
          id: dealer.id,
          label: dealer.name || dealer.address,
          sub: localizedCountry(dealer.country, dealer.countrycode)
        };
      });
      var towns = [];
      var extraPlaces = [];
      var streets = [];
      function publish() {
        if (gen !== suggestGen || !searchInput || searchInput.value.trim() !== value) return;
        var seen = {};
        var merged = [];
        function add(item) {
          var code = item.feature && item.feature.kind === "country" ? item.feature.countrycode : "";
          var key = code ? "cc:" + code : norm(item.label);
          if (!item.label || seen[key]) return;
          seen[key] = true;
          merged.push(item);
        }
        var places = towns.concat(extraPlaces);
        var ordered = /\d/.test(value) ? streets.concat(places) : places.concat(streets);
        var countries = instantCountries(value, lang);
        var rest = [];
        ordered.forEach(function (item) {
          if (item.feature && item.feature.kind === "country") countries.push(item);
          else rest.push(item);
        });
        countries.forEach(add);
        local.forEach(add);
        rest.forEach(add);
        suggestItems = merged.slice(0, 8);
        renderSuggest();
        paintBusy();
      }
      if (local.length || instantCountries(value, lang).length) publish();
      else if (suggestEl) {
        suggestItems = [];
        suggestEl.hidden = true;
        suggestEl.innerHTML = "";
      }
      if (value.length < 2) return;
      var signal = placeAbortSignal();
      var busyId = beginBusy();
      var pending = 2;
      function settle() {
        pending -= 1;
        if (pending > 0) return;
        endBusy(busyId);
        if (gen !== suggestGen || !searchInput || searchInput.value.trim() !== value) return;
        if (!suggestItems.length) renderNotFound();
      }
      placesSearch(value, bias, signal).then(function (items) {
        towns = items;
        publish();
      }).catch(function () {}).then(settle);
      photon(value, 6, signal, bias).then(function (features) {
        if (gen !== suggestGen) return;
        streets = [];
        extraPlaces = [];
        features.forEach(function (feature) {
          if (!feature.label) return;
          var item = {
            kind: "place",
            label: feature.label,
            sub: feature.kind === "country" ? (lang === "de" ? "Land" : "Country") : feature.sub,
            feature: feature
          };
          if (feature.kind === "country" || /\d/.test(feature.label) || feature.label.indexOf(",") !== -1) streets.push(item);
          else extraPlaces.push(item);
        });
        publish();
      }).catch(function () {}).then(settle);
    }

    function commitQuery(value) {
      if (!value) {
        resetView();
        return;
      }
      window.clearTimeout(searchTimer);
      suggestGen += 1;
      clearBusy();
      closeSuggest();
      var known = instantCountries(value, lang).filter(function (item) {
        return item.feature.countrycode === countryCodeFromName(value);
      })[0];
      if (known) {
        queryActive = true;
        showPlace(known.feature, known.label);
        ignoreSuggest = true;
        if (searchInput) searchInput.value = known.label;
        ignoreSuggest = false;
        return;
      }
      queryActive = true;
      function finish() {}
      photonCountry(value).then(function (country) {
        if (searchInput && searchInput.value.trim() !== value) {
          finish();
          return;
        }
        if (country) {
          showPlace(country, value);
          finish();
          return;
        }
        showPlaceOrNearest(value, null, finish);
      }).catch(function () {
        if (searchInput && searchInput.value.trim() !== value) {
          finish();
          return;
        }
        showPlaceOrNearest(value, null, finish);
      });
    }

    function pickSuggest(item) {
      window.clearTimeout(searchTimer);
      suggestGen += 1;
      clearBusy();
      ignoreSuggest = true;
      closeSuggest();
      if (searchInput) searchInput.value = item.label;
      ignoreSuggest = false;
      if (clearBtn) clearBtn.hidden = false;
      if (item.kind === "dealer") {
        clearCountry();
        setPins(null);
        var dealer = dealers.find(function (entry) { return entry.id === item.id; });
        if (!dealer) return;
        if (!routedId) {
          queryActive = false;
          mobilePinId = null;
          homeCards();
        }
        showPinInfo(dealer, true);
        zoomToDealer(dealer);
        return;
      }
      if (item.feature && item.feature.kind === "country") {
        queryActive = true;
        showPlace(item.feature, item.label);
        return;
      }
      queryActive = true;
      showPlaceOrNearest(item.label, item.feature);
    }

    function rememberCountry(feature) {
      if (!feature) return;
      var code = (feature.countrycode || countryCodeFromName(feature.country) || countryCodeFromName(feature.label) || "").toUpperCase();
      if (!code) return;
      var known = COUNTRY_CATALOG.some(function (country) { return country.code === code; });
      if (known) {
        viewCountryCode = code;
        viewCountryChosen = true;
      }
    }

    function fitHome(duration) {
      fitCountryExtent(HOME_EXTENT, duration);
    }

    function fitRememberedCountry() {
      if (!viewCountryChosen) {
        fitHome(motion());
        return;
      }
      var code = viewCountryCode || "CH";
      var hit = COUNTRY_CATALOG.filter(function (country) { return country.code === code; })[0];
      fitCountryExtent(hit ? hit.extent : [5.96, 47.81, 10.49, 45.82]);
    }

    function showPlace(feature, rawQuery) {
      rememberCountry(feature);
      activePlace = { feature: feature, query: rawQuery };
      if (!feature || feature.kind !== "country") {
        clearCountry();
        setPins(null);
        var matches = dealers.filter(function (dealer) {
          if (!feature) return false;
          if (feature.countrycode && dealer.countrycode && dealer.countrycode === feature.countrycode) return true;
          return textHit(dealer, rawQuery) || textHit(dealer, feature.label) || textHit(dealer, feature.country);
        });
        if (feature && feature.lat != null) {
          matches.sort(function (a, b) {
            return distance(feature, a) - distance(feature, b);
          });
        }
        showDealers(matches, config.none);
        return;
      }
      var inCountry = dealers.filter(function (dealer) { return sameCountry(dealer, feature); });
      clearCountry();
      showDealers(inCountry, config.none, inCountry.length ? (feature.label || feature.country) : "");
      setPins(inCountry);
      if (inCountry.length) fitTo(inCountry);
      else fitCountryExtent(countryExtent(feature));
    }

    function countryExtent(feature) {
      if (feature.extent && feature.extent.length === 4) return feature.extent;
      var code = (feature.countrycode || countryCodeFromName(feature.country) || countryCodeFromName(feature.label) || "").toUpperCase();
      var hit = COUNTRY_CATALOG.filter(function (country) { return country.code === code; })[0];
      return hit ? hit.extent : null;
    }

    function sameCountry(dealer, feature) {
      var code = (feature.countrycode || countryCodeFromName(feature.country) || countryCodeFromName(feature.label) || "").toUpperCase();
      var dealerCode = (dealer.countrycode || countryCodeFromName(dealer.country)).toUpperCase();
      if (code && dealerCode) return dealerCode === code;
      var dealerName = norm(dealer.country);
      if (!dealerName) return false;
      return [feature.country, feature.label].some(function (name) { return norm(name) === dealerName; });
    }

    function matchingCountryItem(value) {
      var needle = norm(value);
      if (!needle) return null;
      for (var i = 0; i < suggestItems.length; i++) {
        var item = suggestItems[i];
        if (!item.feature || item.feature.kind !== "country") continue;
        if (norm(item.label) === needle || norm(item.feature.country) === needle || norm(item.feature.countrycode) === needle) return item;
      }
      return null;
    }

    function showCountryShape(feature) {
      var token = ++countryToken;
      fitCountryExtent(feature.extent);
      var code = (feature.countrycode || "").toUpperCase();
      if (code && countryShapes[code]) {
        paintCountry(countryShapes[code], token);
        return;
      }
      var q = feature.country || feature.label || "";
      if (!q) return;
      var url = "https://nominatim.openstreetmap.org/search?q=" + encodeURIComponent(q) +
        "&featuretype=country&format=json&polygon_geojson=1&polygon_threshold=0.018&limit=1";
      if (code) url += "&countrycodes=" + encodeURIComponent(code.toLowerCase());
      fetch(url).then(function (res) {
        if (!res.ok) throw new Error("country");
        return res.json();
      }).then(function (data) {
        if (token !== countryToken) return;
        var geometry = data && data[0] && data[0].geojson;
        if (geometry && geometry.type === "Feature") geometry = geometry.geometry;
        if (!geometry || !geometry.coordinates) return;
        if (code) countryShapes[code] = geometry;
        paintCountry(geometry, token);
      }).catch(function () {});
    }

    function fitCountryExtent(extent, duration) {
      if (!extent) return;
      var run = function () {
        map.fitBounds([
          [extent[0], extent[3]],
          [extent[2], extent[1]]
        ], { padding: 32, duration: duration == null ? motion() : duration });
      };
      if (!mapReady) map.once("load", run);
      else run();
    }

    function paintCountry(geometry, token) {
      if (token !== countryToken) return;
      if (!mapReady) {
        map.once("load", function () { paintCountry(geometry, token); });
        return;
      }
      addCountryLayers();
      map.getSource("ip-country").setData({
        type: "Feature",
        properties: {},
        geometry: geometry
      });
      var bounds = new maplibregl.LngLatBounds();
      eachCoord(geometry, function (coord) { bounds.extend(coord); });
      if (!bounds.isEmpty()) map.fitBounds(bounds, { padding: 32, duration: motion() });
    }

    function eachCoord(geometry, fn) {
      if (!geometry) return;
      if (geometry.type === "Polygon") {
        geometry.coordinates.forEach(function (ring) { ring.forEach(fn); });
      } else if (geometry.type === "MultiPolygon") {
        geometry.coordinates.forEach(function (poly) {
          poly.forEach(function (ring) { ring.forEach(fn); });
        });
      }
    }

    function clearCountry() {
      countryToken += 1;
      if (mapReady && map.getSource("ip-country")) {
        map.getSource("ip-country").setData({ type: "FeatureCollection", features: [] });
      }
    }

    function setPins(list) {
      var allow = null;
      if (list) {
        allow = {};
        list.forEach(function (dealer) { allow[dealer.id] = true; });
      }
      dealers.forEach(function (dealer) {
        var marker = markers[dealer.id];
        if (!marker) return;
        marker.getElement().style.display = !allow || allow[dealer.id] ? "" : "none";
      });
    }

    function addCountryLayers() {
      if (map.getSource("ip-country")) return;
      map.addSource("ip-country", {
        type: "geojson",
        data: { type: "FeatureCollection", features: [] }
      });
      var beforeId = firstSymbolLayer();
      var fill = {
        id: "ip-country-fill",
        type: "fill",
        source: "ip-country",
        paint: { "fill-color": "#e11d1d", "fill-opacity": 0.16 }
      };
      var line = {
        id: "ip-country-line",
        type: "line",
        source: "ip-country",
        paint: { "line-color": "#e11d1d", "line-width": 2 }
      };
      if (beforeId) {
        map.addLayer(fill, beforeId);
        map.addLayer(line, beforeId);
      } else {
        map.addLayer(fill);
        map.addLayer(line);
      }
    }

    function addRouteLayers() {
      if (map.getSource("ip-route")) return;
      map.addSource("ip-route", {
        type: "geojson",
        data: { type: "FeatureCollection", features: [] }
      });
      var beforeId = firstSymbolLayer();
      var casing = {
        id: "ip-route-casing",
        type: "line",
        source: "ip-route",
        layout: { "line-cap": "round", "line-join": "round" },
        paint: { "line-color": "#ffffff", "line-width": 7 }
      };
      var line = {
        id: "ip-route-line",
        type: "line",
        source: "ip-route",
        layout: { "line-cap": "round", "line-join": "round" },
        paint: { "line-color": "#e11d1d", "line-width": 4 }
      };
      if (beforeId) {
        map.addLayer(casing, beforeId);
        map.addLayer(line, beforeId);
      } else {
        map.addLayer(casing);
        map.addLayer(line);
      }
    }

    function firstSymbolLayer() {
      var layers = map.getStyle() && map.getStyle().layers || [];
      for (var i = 0; i < layers.length; i++) {
        if (layers[i].type === "symbol") return layers[i].id;
      }
      return null;
    }

    function clearRoute() {
      routeToken += 1;
      routedId = null;
      routedAltId = null;
      if (originMarker) {
        originMarker.remove();
        originMarker = null;
      }
      if (flagMarker) {
        flagMarker.remove();
        flagMarker = null;
      }
      if (flaggedPin) {
        flaggedPin.hidden = false;
        flaggedPin = null;
      }
      if (mapReady && map.getSource("ip-route")) {
        map.getSource("ip-route").setData({ type: "FeatureCollection", features: [] });
      }
      var routeEl = root.querySelector("[data-ip-route]");
      var altEl = root.querySelector("[data-ip-route-alt]");
      if (routeEl) routeEl.hidden = true;
      if (altEl) altEl.hidden = true;
      root.querySelectorAll(".ip__card--routed").forEach(function (card) {
        card.classList.remove("ip__card--routed");
        card.querySelectorAll(".ip__maplink--open").forEach(function (anchor) {
          anchor.classList.remove("ip__maplink--open");
          var label = anchor.querySelector("[data-ip-maplink-label]");
          if (label && anchor.dataset.idleLabel) label.textContent = anchor.dataset.idleLabel;
        });
      });
      root.querySelectorAll("[data-ip-drive]").forEach(function (node) { node.hidden = true; });
      clearMapFrame();
    }

    function drawRoute(from, dealer) {
      if (!from || from.lat == null || !dealer || dealer.lat == null) return;
      routedId = dealer.id;
      var token = routeToken;
      var routeEl = root.querySelector("[data-ip-route]");
      var pathEl = root.querySelector("[data-ip-route-path]");
      var timeEl = root.querySelector("[data-ip-route-time]");
      var openEl = root.querySelector("[data-ip-route-google]");
      var appleEl = root.querySelector("[data-ip-route-apple]");
      var links = mapLinks(from, dealer);
      if (pathEl) pathEl.textContent = routePath(from, dealer);
      if (timeEl) timeEl.textContent = "";
      var howEl = timeEl ? timeEl.nextElementSibling : null;
      if (howEl) howEl.hidden = true;
      if (openEl) openEl.href = links.google;
      if (appleEl) appleEl.href = links.apple;
      if (routeEl) routeEl.hidden = false;
      setCardRoute(dealer, links, "");
      if (!mapReady) {
        map.once("load", function () { if (token === routeToken) drawRoute(from, dealer); });
        return;
      }
      placeOrigin(from);
      placeFlag(dealer);
      addRouteLayers();
      var url = "https://router.project-osrm.org/route/v1/driving/" +
        from.lng + "," + from.lat + ";" + dealer.lng + "," + dealer.lat +
        "?overview=full&geometries=geojson";
      fetch(url).then(function (res) {
        if (!res.ok) throw new Error("route");
        return res.json();
      }).then(function (data) {
        if (token !== routeToken) return;
        var route = data && data.routes && data.routes[0];
        if (!route || !route.geometry) return;
        map.getSource("ip-route").setData({
          type: "Feature",
          properties: {},
          geometry: route.geometry
        });
        var label = formatDuration(route.duration);
        if (timeEl) timeEl.textContent = label;
        if (howEl) howEl.hidden = false;
        setOriginMinutes(label);
        setCardRoute(dealer, links, label + (lang === "de" ? " mit dem Auto" : " by car"));
        var bounds = new maplibregl.LngLatBounds();
        route.geometry.coordinates.forEach(function (coord) { bounds.extend(coord); });
        bounds.extend([from.lng, from.lat]);
        bounds.extend([dealer.lng, dealer.lat]);
        fitRoute(bounds);
      }).catch(function () {
        if (token !== routeToken) return;
        var bounds = new maplibregl.LngLatBounds();
        bounds.extend([from.lng, from.lat]);
        bounds.extend([dealer.lng, dealer.lat]);
        fitRoute(bounds);
      });
    }

    function routePadding(bounds) {
      if (!phoneLayout()) return 64;
      var sw = bounds.getSouthWest();
      var ne = bounds.getNorthEast();
      var span = Math.max(Math.abs(ne.lat - sw.lat), Math.abs(ne.lng - sw.lng));
      if (span > 0.45) return { top: 78, bottom: 64, left: 96, right: 96 };
      return { top: 52, bottom: 40, left: 48, right: 48 };
    }

    function fitRoute(bounds) {
      frameRoute();
      var padding = routePadding(bounds);
      map.fitBounds(bounds, { padding: padding, duration: motion() });
      window.setTimeout(function () {
        if (!routedId) return;
        frameRoute();
        map.fitBounds(bounds, { padding: padding, duration: 0 });
      }, 360);
    }

    function placeOrigin(from) {
      if (originMarker) originMarker.remove();
      var chip = document.createElement("div");
      chip.className = "ip__start";
      chip.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/></svg><span data-ip-start-label></span>';
      originMarker = new maplibregl.Marker({ element: chip, anchor: "bottom" })
        .setLngLat([from.lng, from.lat])
        .addTo(map);
    }

    function setOriginMinutes(text) {
      if (!originMarker || !text) return;
      var label = originMarker.getElement().querySelector("[data-ip-start-label]");
      if (label) label.textContent = text;
    }

    function placeFlag(dealer) {
      if (flagMarker) flagMarker.remove();
      if (flaggedPin) {
        flaggedPin.hidden = false;
        flaggedPin = null;
      }
      var flag = document.createElement("div");
      flag.className = "ip__flag";
      flag.setAttribute("aria-hidden", "true");
      flag.innerHTML = '<svg viewBox="0 0 28 36" aria-hidden="true"><path d="M6 1.5v33" fill="none" stroke="#e11d1d" stroke-width="2.2" stroke-linecap="round"/><rect x="7" y="3" width="18" height="14" rx="1.2" fill="#fff" stroke="#1d1d1f" stroke-width="1"/><rect x="7" y="3" width="6" height="4.67" fill="#1d1d1f"/><rect x="19" y="3" width="6" height="4.67" fill="#1d1d1f"/><rect x="13" y="7.67" width="6" height="4.67" fill="#1d1d1f"/><rect x="7" y="12.33" width="6" height="4.67" fill="#1d1d1f"/><rect x="19" y="12.33" width="6" height="4.67" fill="#1d1d1f"/></svg>';
      flagMarker = new maplibregl.Marker({ element: flag, anchor: "bottom" })
        .setLngLat([dealer.lng, dealer.lat])
        .addTo(map);
      if (markers[dealer.id]) {
        flaggedPin = markers[dealer.id].getElement();
        flaggedPin.hidden = true;
      }
    }

    function mapLinks(from, dealer) {
      var dest = dealer.lat + "," + dealer.lng;
      var start = from && from.lat != null ? from.lat + "," + from.lng : "";
      var google = "https://www.google.com/maps/dir/?api=1&destination=" + dest + "&travelmode=driving";
      var apple = "https://maps.apple.com/?daddr=" + dest + "&dirflg=d";
      if (start) {
        google += "&origin=" + start;
        apple = "https://maps.apple.com/?saddr=" + start + "&daddr=" + dest + "&dirflg=d";
      }
      return { google: google, apple: apple };
    }

    function setCardRoute(dealer, links, driveText) {
      var card = root.querySelector('[data-ip-card][data-id="' + cssEscape(dealer.id) + '"]');
      if (!card) return;
      var google = card.querySelector("[data-ip-google]");
      var apple = card.querySelector("[data-ip-apple]");
      var drive = card.querySelector("[data-ip-drive]");
      var driveTextEl = card.querySelector("[data-ip-drive-text]");
      card.classList.add("ip__card--routed");
      setMapLink(google, links.google, true);
      setMapLink(apple, links.apple, true);
      if (drive) drive.hidden = !driveText;
      if (driveTextEl) driveTextEl.textContent = driveText || "";
    }

    function setMapLink(anchor, href, open) {
      if (!anchor) return;
      anchor.href = href;
      anchor.classList.toggle("ip__maplink--open", !!open);
      var label = anchor.querySelector("[data-ip-maplink-label]");
      if (!label) return;
      if (!anchor.dataset.idleLabel) anchor.dataset.idleLabel = label.textContent;
      label.textContent = open && anchor.dataset.openLabel ? anchor.dataset.openLabel : anchor.dataset.idleLabel;
    }

    function formatDuration(seconds) {
      var minutes = Math.max(1, Math.round(Number(seconds) / 60));
      if (minutes < 60) return lang === "de" ? minutes + " Min." : minutes + " min";
      var hours = Math.floor(minutes / 60);
      var rest = minutes % 60;
      if (!rest) return lang === "de" ? hours + " Std." : hours + " h";
      return lang === "de" ? hours + " Std. " + rest + " Min." : hours + " h " + rest + " min";
    }

    function fitTo(list) {
      var points = list.filter(function (dealer) {
        return dealer.lat != null && dealer.lng != null;
      });
      if (!points.length) return;
      if (points.length === 1) {
        map.flyTo({ center: [points[0].lng, points[0].lat], zoom: 12, duration: motion() });
        return;
      }
      var bounds = new maplibregl.LngLatBounds();
      points.forEach(function (dealer) { bounds.extend([dealer.lng, dealer.lat]); });
      map.fitBounds(bounds, { padding: 48, maxZoom: 11, duration: motion() });
    }

    function textMatches(value) {
      return dealers.filter(function (dealer) { return textHit(dealer, value); });
    }

    function localizedCountry(name, code) {
      var resolved = code || countryCodeFromName(name);
      for (var i = 0; i < COUNTRY_CATALOG.length; i++) {
        if (COUNTRY_CATALOG[i].code === resolved) {
          return lang === "de" ? COUNTRY_CATALOG[i].de : COUNTRY_CATALOG[i].en;
        }
      }
      return name || "";
    }

    function localizeCountryLabels() {
      root.querySelectorAll("[data-ip-card]").forEach(function (card) {
        var dealer = dealers.find(function (entry) { return entry.id === card.dataset.id; });
        if (!dealer) return;
        var el = card.querySelector(".ip__card-country");
        if (el) el.textContent = localizedCountry(dealer.country, dealer.countrycode);
      });
    }

    function applyMapLanguage() {
      var style = map.getStyle();
      if (!style || !style.layers) return;
      var field = lang === "de"
        ? ["coalesce", ["get", "name:de"], ["get", "name_de"], ["get", "name:latin"], ["get", "name"]]
        : ["coalesce", ["get", "name:en"], ["get", "name_en"], ["get", "name:latin"], ["get", "name"]];
      style.layers.forEach(function (layer) {
        if (layer.type !== "symbol") return;
        try {
          var current = map.getLayoutProperty(layer.id, "text-field");
          var raw = JSON.stringify(current || "");
          if (raw.indexOf("name") === -1) return;
          if (raw.indexOf("\"ref\"") !== -1) return;
          map.setLayoutProperty(layer.id, "text-field", field);
        } catch (err) {}
      });
    }

    function textHit(dealer, value) {
      var hay = norm([dealer.name, dealer.country, localizedCountry(dealer.country, dealer.countrycode), dealer.address, dealer.note].join(" "));
      var needle = norm(value);
      if (!needle) return false;
      if (hay.indexOf(needle) !== -1) return true;
      var country = norm(dealer.country);
      return country.length > 2 && needle === country;
    }

    function beginBusy() {
      var id = ++busySeq;
      busyIds[id] = true;
      paintBusy();
      return id;
    }

    function endBusy(id) {
      if (!busyIds[id]) return;
      delete busyIds[id];
      paintBusy();
    }

    function clearBusy() {
      busyIds = {};
      paintBusy();
    }

    function paintBusy() {
      var on = false;
      for (var key in busyIds) {
        if (busyIds[key]) {
          on = true;
          break;
        }
      }
      var listOpen = suggestEl && !suggestEl.hidden && suggestItems.length > 0;
      if (spinEl) spinEl.hidden = !on || listOpen;
      if (searchInput) {
        if (on) searchInput.setAttribute("aria-busy", "true");
        else searchInput.removeAttribute("aria-busy");
      }
    }

    function renderNotFound() {
      if (!suggestEl) return;
      suggestEl.innerHTML = "";
      suggestIndex = -1;
      var li = document.createElement("li");
      li.className = "ip__suggest-empty";
      li.textContent = notFound;
      suggestEl.appendChild(li);
      suggestEl.hidden = false;
    }

    function renderSuggest() {
      if (!suggestEl) return;
      suggestEl.innerHTML = "";
      suggestIndex = -1;
      if (!suggestItems.length) {
        suggestEl.hidden = true;
        return;
      }
      suggestItems.forEach(function (item, index) {
        var li = document.createElement("li");
        var button = document.createElement("button");
        button.type = "button";
        button.setAttribute("role", "option");
        var label = document.createElement("span");
        label.textContent = item.label;
        button.appendChild(label);
        if (item.sub) {
          var sub = document.createElement("span");
          sub.className = "ip__suggest-sub";
          sub.textContent = item.sub;
          button.appendChild(sub);
        }
        button.addEventListener("click", function () { pickSuggest(item); });
        button.addEventListener("mouseenter", function () { setSuggestIndex(index); });
        li.appendChild(button);
        suggestEl.appendChild(li);
      });
      suggestEl.hidden = false;
    }

    function setSuggestIndex(index) {
      var buttons = suggestEl.querySelectorAll("button");
      if (!buttons.length) return;
      if (index < 0) index = buttons.length - 1;
      if (index >= buttons.length) index = 0;
      suggestIndex = index;
      buttons.forEach(function (button, i) {
        button.setAttribute("aria-selected", i === index ? "true" : "false");
      });
    }

    function closeSuggest() {
      if (!suggestEl) return;
      suggestEl.hidden = true;
      suggestEl.innerHTML = "";
      suggestItems = [];
      suggestIndex = -1;
    }

    function placeAbortSignal() {
      if (placeAbort) placeAbort.abort();
      placeAbort = new AbortController();
      return placeAbort.signal;
    }

    function biasPoint() {
      if (!map || !map.getCenter) return null;
      var center = map.getCenter();
      return { lat: center.lat, lng: center.lng };
    }

    function placeScore(item, bias) {
      if (!bias || item.lat == null) return 0;
      return distance(item, bias) - Math.log((item.population || 0) + 1) * 80;
    }

    function umlautQuery(value) {
      var next = value
        .replace(/ae/g, "ä").replace(/oe/g, "ö").replace(/ue/g, "ü")
        .replace(/Ae/g, "Ä").replace(/Oe/g, "Ö").replace(/Ue/g, "Ü");
      return next === value ? "" : next;
    }

    function placesSearch(query, bias, signal) {
      var queries = [query];
      var folded = umlautQuery(query);
      if (folded) queries.push(folded);
      return Promise.all(queries.map(function (part) {
        var url = "https://geocoding-api.open-meteo.com/v1/search?name=" + encodeURIComponent(part) + "&count=6&language=" + lang + "&format=json";
        return fetch(url, { signal: signal }).then(function (res) {
          if (!res.ok) return [];
          return res.json();
        }).then(function (data) {
          return (data && data.results) || [];
        }).catch(function () { return []; });
      })).then(function (groups) {
        var seen = {};
        var items = [];
        groups.forEach(function (rows) {
          rows.forEach(function (row) {
            if (row.latitude == null || !row.name || seen[row.id]) return;
            if (row.feature_code && row.feature_code.indexOf("PPL") !== 0) return;
            seen[row.id] = true;
            var region = String(row.admin1 || "").replace(/^Kanton\s+/i, "");
            var feature = {
              lat: row.latitude,
              lng: row.longitude,
              label: row.name,
              country: row.country || "",
              countrycode: (row.country_code || "").toUpperCase(),
              extent: null,
              kind: "place",
              population: row.population || 0
            };
            items.push({
              kind: "place",
              label: row.name,
              sub: [region, row.country].filter(Boolean).join(", "),
              feature: feature
            });
          });
        });
        items.sort(function (a, b) {
          return placeScore(a.feature, bias) - placeScore(b.feature, bias);
        });
        return items.slice(0, 5);
      });
    }

    function photon(query, limit, signal, bias) {
      var url = "https://photon.komoot.io/api/?q=" + encodeURIComponent(query) + "&limit=" + limit + "&lang=" + lang;
      if (bias && bias.lat != null && bias.lng != null) url += "&lat=" + bias.lat + "&lon=" + bias.lng;
      return fetch(url, { signal: signal }).then(function (res) {
        if (!res.ok) throw new Error("geo");
        return res.json();
      }).then(function (data) {
        return (data.features || []).map(mapFeature);
      });
    }

    function photonCountry(query) {
      var url = "https://photon.komoot.io/api/?q=" + encodeURIComponent(query) + "&limit=1&lang=" + lang + "&osm_tag=place:country";
      return fetch(url).then(function (res) {
        if (!res.ok) return null;
        return res.json();
      }).then(function (data) {
        var feature = data && data.features && data.features[0];
        if (!feature) return null;
        var mapped = mapFeature(feature);
        if (!mapped.countrycode && mapped.lat == null) return null;
        mapped.kind = "country";
        return mapped;
      }).catch(function () { return null; });
    }

    function mapFeature(feature) {
      var props = feature.properties || {};
      var coords = (feature.geometry && feature.geometry.coordinates) || [null, null];
      var kind = props.osm_value === "country" || props.osm_key === "place" && props.osm_value === "country" ? "country" : "place";
      var street = [props.street || (props.osm_key === "highway" ? props.name : ""), props.housenumber].filter(Boolean).join(" ");
      var locality = [props.postcode, props.city || props.locality || props.district].filter(Boolean).join(" ");
      var label = street || props.name || props.city || props.country || "";
      var subParts = [props.state, props.country].filter(function (part, index, all) {
        return part && part !== label && label.indexOf(part) === -1 && all.indexOf(part) === index;
      });
      if (street && locality) label = street + ", " + locality;
      return {
        lat: coords[1],
        lng: coords[0],
        label: label,
        sub: subParts.slice(0, 2).join(", "),
        country: props.country || "",
        countrycode: (props.countrycode || "").toUpperCase(),
        extent: props.extent || null,
        kind: kind
      };
    }
  }

  function coord(value) {
    if (value == null || String(value).trim() === "") return null;
    var number = Number(String(value).replace(",", "."));
    return Number.isFinite(number) ? number : null;
  }

  function norm(value) {
    return String(value || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();
  }

  var COUNTRY_CATALOG = [
    { code: "CH", de: "Schweiz", en: "Switzerland", extent: [5.96, 47.81, 10.49, 45.82], extra: ["suisse", "svizzera", "svizra"] },
    { code: "DE", de: "Deutschland", en: "Germany", extent: [5.87, 55.06, 15.04, 47.27], extra: ["allemagne"] },
    { code: "AT", de: "Österreich", en: "Austria", extent: [9.53, 49.02, 17.17, 46.37], extra: ["autriche"] },
    { code: "LI", de: "Liechtenstein", en: "Liechtenstein", extent: [9.47, 47.27, 9.64, 47.05], extra: [] },
    { code: "FR", de: "Frankreich", en: "France", extent: [-5.15, 51.09, 9.56, 41.33], extra: [] },
    { code: "IT", de: "Italien", en: "Italy", extent: [6.63, 47.10, 18.52, 36.65], extra: ["italia"] },
    { code: "ES", de: "Spanien", en: "Spain", extent: [-9.39, 43.79, 4.33, 35.95], extra: ["espana", "espagne"] },
    { code: "PT", de: "Portugal", en: "Portugal", extent: [-9.50, 42.15, -6.19, 36.96], extra: [] },
    { code: "GB", de: "Vereinigtes Königreich", en: "United Kingdom", extent: [-8.65, 60.86, 1.76, 49.16], extra: ["uk", "grossbritannien", "great britain", "england"] },
    { code: "IE", de: "Irland", en: "Ireland", extent: [-10.48, 55.39, -5.99, 51.45], extra: [] },
    { code: "NL", de: "Niederlande", en: "Netherlands", extent: [3.36, 53.56, 7.23, 50.75], extra: ["holland"] },
    { code: "BE", de: "Belgien", en: "Belgium", extent: [2.55, 51.51, 6.40, 49.50], extra: ["belgique"] },
    { code: "LU", de: "Luxemburg", en: "Luxembourg", extent: [5.74, 50.18, 6.53, 49.45], extra: [] },
    { code: "DK", de: "Dänemark", en: "Denmark", extent: [8.09, 57.75, 15.16, 54.56], extra: ["danemark"] },
    { code: "SE", de: "Schweden", en: "Sweden", extent: [11.11, 69.06, 24.17, 55.34], extra: [] },
    { code: "NO", de: "Norwegen", en: "Norway", extent: [4.65, 71.19, 31.08, 57.98], extra: [] },
    { code: "FI", de: "Finnland", en: "Finland", extent: [20.55, 70.09, 31.59, 59.81], extra: [] },
    { code: "PL", de: "Polen", en: "Poland", extent: [14.12, 54.84, 24.15, 49.00], extra: [] },
    { code: "CZ", de: "Tschechien", en: "Czechia", extent: [12.09, 51.06, 18.86, 48.55], extra: ["tschechische republik", "czech republic"] },
    { code: "SK", de: "Slowakei", en: "Slovakia", extent: [16.84, 49.61, 22.57, 47.73], extra: [] },
    { code: "HU", de: "Ungarn", en: "Hungary", extent: [16.11, 48.59, 22.90, 45.74], extra: [] },
    { code: "SI", de: "Slowenien", en: "Slovenia", extent: [13.38, 46.88, 16.61, 45.42], extra: [] },
    { code: "HR", de: "Kroatien", en: "Croatia", extent: [13.49, 46.55, 19.43, 42.39], extra: [] },
    { code: "GR", de: "Griechenland", en: "Greece", extent: [19.37, 41.75, 28.25, 34.80], extra: [] },
    { code: "US", de: "USA", en: "United States", extent: [-125.0, 49.38, -66.93, 24.40], extra: ["usa", "vereinigte staaten", "united states of america"] },
    { code: "CA", de: "Kanada", en: "Canada", extent: [-141.0, 83.11, -52.64, 41.68], extra: [] },
    { code: "AU", de: "Australien", en: "Australia", extent: [112.92, -10.06, 153.64, -43.64], extra: [] },
    { code: "NZ", de: "Neuseeland", en: "New Zealand", extent: [166.43, -34.39, 178.57, -47.29], extra: [] }
  ];

  COUNTRY_CATALOG.forEach(function (country) {
    country.names = [country.de, country.en].concat(country.extra).map(norm).filter(Boolean);
  });

  function countryCodeFromName(name) {
    var needle = norm(name);
    if (!needle) return "";
    for (var i = 0; i < COUNTRY_CATALOG.length; i++) {
      if (COUNTRY_CATALOG[i].names.indexOf(needle) !== -1) return COUNTRY_CATALOG[i].code;
    }
    return "";
  }

  function instantCountries(value, lang) {
    var needle = norm(value);
    if (needle.length < 3) return [];
    var hits = [];
    COUNTRY_CATALOG.forEach(function (country) {
      var exact = false;
      var matched = false;
      country.names.forEach(function (name) {
        if (name.indexOf(needle) !== 0) return;
        matched = true;
        if (name === needle) exact = true;
      });
      if (!matched) return;
      hits.push({
        country: country,
        exact: exact,
        gap: country.names[0].length - needle.length
      });
    });
    hits.sort(function (a, b) {
      if (a.exact !== b.exact) return a.exact ? -1 : 1;
      return a.gap - b.gap;
    });
    return hits.slice(0, 2).map(function (hit) {
      var label = lang === "de" ? hit.country.de : hit.country.en;
      var extent = hit.country.extent;
      return {
        kind: "place",
        label: label,
        sub: lang === "de" ? "Land" : "Country",
        feature: {
          lat: (extent[3] + extent[1]) / 2,
          lng: (extent[0] + extent[2]) / 2,
          label: label,
          country: label,
          countrycode: hit.country.code,
          extent: extent,
          kind: "country"
        }
      };
    });
  }

  function distance(a, b) {
    if (a.lat == null || b.lat == null) return 1e9;
    var r = 6371;
    var dLat = (b.lat - a.lat) * Math.PI / 180;
    var dLon = (b.lng - a.lng) * Math.PI / 180;
    var lat1 = a.lat * Math.PI / 180;
    var lat2 = b.lat * Math.PI / 180;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 2 * r * Math.asin(Math.min(1, Math.sqrt(h)));
  }

  function motion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 700;
  }

  function cssEscape(value) {
    if (window.CSS && CSS.escape) return CSS.escape(value);
    return String(value).replace(/"/g, "");
  }

  function readCache() {
    try {
      return JSON.parse(localStorage.getItem(CACHE_KEY) || "{}");
    } catch (err) {
      return {};
    }
  }

  function writeCache(store) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify(store));
    } catch (err) {}
  }

  function wait(ms) {
    return new Promise(function (resolve) { window.setTimeout(resolve, ms); });
  }

  function start() {
    boot(document);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();

  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });
})();
